// assets
import { IconRobot } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| AGENTS MENU ITEM ||============================== //

const icons = {
  IconRobot
};

const agents: NavItemType = {
  id: 'agents',
  title: 'agents',
  icon: icons.IconRobot,
  type: 'group',
  url: '/agents',
  chip: {
    label: 'Soon',
    size: 'small',
    variant: 'outlined',
  }
};

export default agents;
